/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      var total_cart_price = cart.total_price;
      //console.log(total_cart_price);

      if(localStorage.getItem('promotion_type') == 'minimum_spend' && localStorage.getItem('free_pdp_json') != ''){
        var minimum_spend_value = parseInt(localStorage.getItem('minimum_spend'));
        var gwp_free_id = parseInt(free_pdp_json['id']);

        if(total_cart_price < minimum_spend_value){
          var myJson = cart.items;
          var gwp_free = myJson.filter(function (item2){
            return item2.product_id === gwp_free_id;
          });
          var haveFree = gwp_free[0];
          if(haveFree){
            setTimeout(function() {
              //ShopifyAPI.changeItem(line, qty, adjustCartCallback);
              //line, quantity, callback
              var $body = $(document.body),
                  params = {
                    type: 'POST',
                    url: '/cart/update.js',
                    data : "updates["+gwp_free_var_id+"]=0",
                    dataType: 'json',
                    success: function(cart) {
                      callback(cart);
                    },
                    error: function(XMLHttpRequest, textStatus) {
                      ShopifyAPI.onCartUpdate(cart);
                    }
                  };
              jQuery.ajax(params);
            }, 250);
          }
        }
      }
      
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : '.CartCost',
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {    
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    
    var groundShippingthresold = 15000;
    var day2Shippingthresold = 50000;
    
    var freegroundShipping = '';
    var day2Shipping = '';
    var groundHide = '';
    var day2Hide = '';
    
    if(groundShippingthresold > 0){
      if(cart.total_price > groundShippingthresold){
        var hidefree = 'hide';
      } else {
        var hidefree = 'hide1';
        var day2reminderhide = 'hide';
        var day2Hide = 'day2hide';
        var firstthresold = groundShippingthresold - cart.total_price;
        var freegroundShipping = 'SPEND '+Shopify.formatMoney(firstthresold, settings.moneyFormat)+' MORE & GET FREE GROUND SHIPPING!';
      }
    }
    
    if(day2Shippingthresold > 0){
      if(cart.total_price > groundShippingthresold){
        if(cart.total_price < day2Shippingthresold){
          var day2reminderhide = 'hide1';
          var day2reminder = day2Shippingthresold - cart.total_price; 
          var day2Shipping = 'SPEND '+Shopify.formatMoney(day2reminder, settings.moneyFormat)+' MORE & GET FREE 2DAY SHIPPING!';
        } else {
          var day2reminderhide = 'hide';
          var groundHide = 'ground-hide';
        }
      }
    }
    
    $('.shopping-cart-promotion').addClass('hide');
    
    // Start with a fresh cart div
    $cartContainer.empty();

    var tagLimitation = '';
    
    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your bag is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    var cartQaulifyQty = 0;	
    var cartQaulifyValue = 0;	
    	
    var itemCount = cart.item_count;	
    var totalCart = cart.total_price;
    
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      console.log(cartItem);

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var haveFreePRD = 1;	
      var haveFreeClass = '';	
      	
      var gwp_free_id = parseInt(free_pdp_json['id']);	
      var price = Shopify.formatMoney(cartItem.price, settings.moneyFormat)	
      if(cartItem.product_id == gwp_free_id){	
      	haveFreePRD = 0;	
        var haveFreeClass = 'hide';	
        price = 'Free';	
      }	
      	
      var isLastElement = index == cart.items.length -1;	
      	
      if(localStorage.getItem('promotion_type') == 'minimum_quantity') {	
        var minimum_qty_value = localStorage.getItem('minimum_qty');	
        	
        if(tagLimitation.length > 0){	
          var tagValue = cartItem.properties._tag;	
          if(typeof tagValue != 'undefined' && tagValue == tagLimitation) {	
            cartQaulifyQty += cartItem.quantity;	
          }	
        } else {	
          if(cartItem.product_type == "Gift Cards" || cartItem.product_type == "Gift Card" || cartItem.product_id === gwp_free_id){	
            cartQaulifyQty += cartItem.quantity;	
          }	
        }	
        	
        if (isLastElement) {	
          if(tagLimitation.length > 0){	
            itemCount = cartQaulifyQty;	
          } else {	
            itemCount = itemCount - cartQaulifyQty;	
          }	
          	
          if(itemCount >= parseInt(minimum_qty_value)){	
            $('.shopping-cart-promotion').removeClass('hide');	
          } else {	
          	setTimeout(function() {	
              var gwp_free_var_id = parseInt(free_pdp_json['variant-id']);	
              if($('.ajaxcart__qty-num[data-id="'+gwp_free_var_id+'"]').length > 0){	
                $('.ajaxcart__qty-num[data-id="'+gwp_free_var_id+'"]').val(0).change();	
              }	
            },200);	
          }	
        }	
      } else if(localStorage.getItem('promotion_type') == 'minimum_spend') {	
        var minimum_spend_value = localStorage.getItem('minimum_spend');	
        
        if(tagLimitation.length > 0){	
          var tagValue = cartItem.properties._tag;	
          if(typeof tagValue != 'undefined' && tagValue == tagLimitation) {	
            cartQaulifyValue += cartItem.line_price;	
          }	
        } else {	
          if(cartItem.product_type == "Gift Cards" || cartItem.product_type == "Gift Card" || cartItem.product_id === gwp_free_id){	
            cartQaulifyValue += cartItem.line_price;
          }	
        }	
        
        if (isLastElement) {	
          if(tagLimitation.length > 0){	
            totalCart = cartQaulifyValue;		
          } else {	
            totalCart = totalCart - cartQaulifyValue;	
          }	
          
          if(totalCart >= parseInt(minimum_spend_value)){	
            $('.shopping-cart-promotion').removeClass('hide');	
          } else {	
          	setTimeout(function() {	
              var gwp_free_var_id = parseInt(free_pdp_json['variant-id']);	
              if($('.ajaxcart__qty-num[data-id="'+gwp_free_var_id+'"]').length > 0){	
                $('.ajaxcart__qty-num[data-id="'+gwp_free_var_id+'"]').val(0).change();	
              }	
            },200);	
          }	
        }	
      }
      
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        haveprdfree: haveFreePRD,	
        haveFreeClass:haveFreeClass,
        sellingPlan: cartItem.selling_plan_allocation
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      freegroundShipping: freegroundShipping,
      hidefree: hidefree,
      day2Shipping: day2Shipping,
      day2reminderhide: day2reminderhide,
      groundHide:groundHide,
      day2Hide: day2Hide,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
    
     if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }   
    
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          idpdp = parseInt($el.data('id')),	
          thisd = $el,
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      //console.log(gwp_base_var_id);	
      //console.log(gwp_free_var_id);	
      if(idpdp == gwp_base_var_id){	
        if(qty == 0){	
        	updateQuantityBundle(thisd,line, qty);	
        } else {	
          if(qty < parseInt(localStorage.getItem('base_pdp_qty'))){	
            updateQuantityBase(thisd,line, qty);	
            //$qtySelector.val(qty);	
          } else if(line) {	
            updateQuantity(line, qty);	
          } else {	
            $qtySelector.val(qty);	
          }	
        }	
      } else {	
        // If it has a data-line, update the cart.	
        // Otherwise, just update the input's number	
        if (line) {	
          updateQuantity(line, qty);	
        } else {	
          $qtySelector.val(qty);	
        }	
      }
      
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    $body.on('click', '.cart__remove', function(evt) {	
      var gwp_free_id = parseInt(free_pdp_json['id']);  	
      var varid = $(this).closest('.cart__row').data('varid');	
      if(varid == gwp_base_var_id){	
        var $body = $(document.body),	
            params = {	
              type: 'POST',	
              url: '/cart/update.js',	
              data : "updates["+gwp_base_var_id+"]=0&updates["+gwp_free_var_id+"]=0",	
              dataType: 'json',	
              success: function(cart) {	
                location.reload();	
              },	
              error: function(XMLHttpRequest, textStatus) {	
                ShopifyAPI.onError(XMLHttpRequest, textStatus);	
              }	
            };	
        jQuery.ajax(params);	
        return false;	
      } else {	
        var params = {	
          type: 'POST',	
          url: '/cart/update.js',	
          data : "updates["+varid+"]=0",	
          dataType: 'json',	
          success: function(cart) {	
            var total_cart_price = cart.total_price;	
            var myJson = cart.items;	
            var gwp_free = myJson.filter(function (item2){	
              return item2.product_id === gwp_free_id;	
            });	
            var haveFreed = gwp_free[0];	
            	
            if(haveFreed){	
              if(localStorage.getItem('promotion_type') == 'minimum_spend' && localStorage.getItem('free_pdp_json') != ''){	
                var minimum_spend_value = parseInt(localStorage.getItem('minimum_spend'));	
                if(total_cart_price < minimum_spend_value){	
                  //ShopifyAPI.changeItem(line, qty, adjustCartCallback);	
                  //line, quantity, callback	
                  var paramss = {	
                    type: 'POST',	
                    url: '/cart/update.js',	
                    data : "updates["+gwp_free_var_id+"]=0",	
                    dataType: 'json',	
                    success: function(cart) {	
                      location.reload();	
                    },	
                    error: function(XMLHttpRequest, textStatus) {	
                      location.reload();	
                    }	
                  };	
                  jQuery.ajax(paramss);	
                  return false;	
                } else {	
                  location.reload();	
                }	
              }	
            } else {	
              location.reload();	
            }	
            return false;	
          },	
          error: function(XMLHttpRequest, textStatus) {	
            ShopifyAPI.onError(XMLHttpRequest, textStatus);	
          }	
        };	
        jQuery.ajax(params);	
      }	
      return false;	
    });
    
    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    function updateQuantityBundle(thisd,line, qty) {	
      isUpdating = true;	
      // Slight delay to make sure removed animation is done	
      setTimeout(function() {	
        //ShopifyAPI.changeItem(line, qty, adjustCartCallback);	
        //line, quantity, callback	
        var $body = $(document.body),	
            params = {	
              type: 'POST',	
              url: '/cart/update.js',	
              data : "updates["+gwp_base_var_id+"]=0&updates["+gwp_free_var_id+"]=0",	
              dataType: 'json',	
              success: function(cart) {	
                ShopifyAPI.getCart(cartUpdateCallback);	
                //$body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);	
              },	
              error: function(XMLHttpRequest, textStatus) {	
                ShopifyAPI.onError(XMLHttpRequest, textStatus);	
              }	
            };	
        jQuery.ajax(params);	
      }, 250);	
    }	
    	
    function updateQuantityBase(thisd,line, qty) {	
      isUpdating = true;	
      // Slight delay to make sure removed animation is done	
      setTimeout(function() {	
        //ShopifyAPI.changeItem(line, qty, adjustCartCallback);	
        //line, quantity, callback	
        var $body = $(document.body),	
            params = {	
              type: 'POST',	
              url: '/cart/update.js',	
              data : "updates["+gwp_base_var_id+"]="+qty+"&updates["+gwp_free_var_id+"]=0",	
              dataType: 'json',	
              success: function(cart) {	
                ShopifyAPI.getCart(cartUpdateCallback);	
                //$body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);	
              },	
              error: function(XMLHttpRequest, textStatus) {	
                ShopifyAPI.onError(XMLHttpRequest, textStatus);	
              }	
            };	
        jQuery.ajax(params);	
      }, 250);	
    }
    
    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
